module.exports = __webpack_public_path__ + "img/etapas-menu.bf89af37.png";